(() => {
  const media = matchMedia('(prefers-reduced-motion: reduce)');
  let choice = 'auto';
  try { const saved=localStorage.getItem('td-motion'); if(['auto','on','off'].includes(saved))choice=saved; } catch (_) {}
  window.tdMotion = {enabled:()=>choice==='on'||(choice==='auto'&&!media.matches)};
  function announce(){document.dispatchEvent(new Event('td:motion-change'));}
  media.addEventListener('change',announce);
  document.addEventListener('DOMContentLoaded',()=>{
    const select=document.getElementById('td-motion-setting');
    if(select){select.value=choice;select.addEventListener('change',()=>{choice=select.value;try{localStorage.setItem('td-motion',choice)}catch(_){}announce()});}
    announce();
  });
})();
